
import { Link } from 'react-router-dom';

const allCities = [
  { name: 'Barcelona Ciudad', slug: '/desguace-barcelona-ciudad' },
  { name: 'Badalona', slug: '/desguace-badalona' },
  { name: "L'Hospitalet", slug: '/desguace-hospitalet' },
  { name: 'Santa Coloma', slug: '/desguace-santa-coloma' },
  { name: 'Sant Adrià', slug: '/desguace-sant-adria' },
  { name: 'Montgat', slug: '/desguace-montgat' },
  { name: 'Sabadell', slug: '/desguace-sabadell' },
  { name: 'Terrassa', slug: '/desguace-terrassa' },
  { name: 'Sant Cugat', slug: '/desguace-sant-cugat' },
  { name: 'Rubí', slug: '/desguace-rubi' },
  { name: 'Cerdanyola', slug: '/desguace-cerdanyola' },
  { name: 'Barberà', slug: '/desguace-barbera' },
  { name: 'Ripollet', slug: '/desguace-ripollet' },
  { name: 'Montcada', slug: '/desguace-montcada' },
  { name: 'Castellbisbal', slug: '/desguace-castellbisbal' },
  { name: 'Cornellà', slug: '/desguace-cornella' },
  { name: 'Esplugues', slug: '/desguace-esplugues' },
  { name: 'Gavà', slug: '/desguace-gava' },
  { name: 'Sant Boi', slug: '/desguace-sant-boi' },
  { name: 'El Prat', slug: '/desguace-el-prat' },
  { name: 'Viladecans', slug: '/desguace-viladecans' },
  { name: 'Castelldefels', slug: '/desguace-castelldefels' },
  { name: 'Martorell', slug: '/desguace-martorell' },
  { name: 'Sant Andreu de la Barca', slug: '/desguace-sant-andreu-barca' },
  { name: 'Granollers', slug: '/desguace-granollers' },
  { name: 'Mollet', slug: '/desguace-mollet' },
  { name: 'Mataró', slug: '/desguace-mataro' },
  { name: 'Premià de Mar', slug: '/desguace-premia-de-mar' },
  { name: 'Vilassar de Mar', slug: '/desguace-vilassar-de-mar' },
  { name: 'Vilafranca', slug: '/desguace-vilafranca' },
  { name: 'Igualada', slug: '/desguace-igualada' },
  { name: 'Manresa', slug: '/desguace-manresa' },
];

export default function ZoneCityGrid() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl font-bold text-[#1a2332] mb-4">
            Todas Nuestras Zonas de Servicio
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Haz clic en cualquier ciudad para ver los barrios y zonas específicas donde operamos, junto con las ventajas de nuestro servicio local.
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
          {allCities.map((city) => (
            <Link
              key={city.slug}
              to={city.slug}
              className="group bg-[#fafbfc] hover:bg-[#ff6b35]/5 border border-gray-100 hover:border-[#ff6b35]/30 rounded-xl p-4 text-center transition-all hover:shadow-md cursor-pointer"
            >
              <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-[#ff6b35]/10 flex items-center justify-center group-hover:bg-[#ff6b35]/20 transition-colors">
                <i className="ri-map-pin-2-fill text-[#ff6b35] text-lg"></i>
              </div>
              <p className="text-sm font-medium text-[#1a2332] group-hover:text-[#ff6b35] transition-colors leading-tight">
                {city.name}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
